<template>
  <div class="fullscreen-load">
    <cert-loader></cert-loader>
  </div>
</template>

<script>
import CertLoader from './CertLoader'
export default {
  name: 'CertFullPageLoader',
  components: {
    CertLoader
  }
}
</script>

<style lang="scss" scoped>
.fullscreen-load {
  display: flex;
  min-height: 100%;
  align-items: center;

  > div {
    margin: auto;
  }
}
</style>